import { render, staticRenderFns } from "./quikr.vue?vue&type=template&id=40774e34&scoped=true"
import script from "./quikr.vue?vue&type=script&lang=js"
export * from "./quikr.vue?vue&type=script&lang=js"
import style0 from "./quikr.vue?vue&type=style&index=0&id=40774e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40774e34",
  null
  
)

export default component.exports